/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { separatorStyles, wrapperStyle } from '@atlaskit/editor-common/styles';
export default (function () {
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("span", {
      css: wrapperStyle
    }, jsx("span", {
      "data-vc": "primary-toolbar-separator",
      css: separatorStyles
    }))
  );
});